import React from "react";
import Pill from "../../ui/atoms/Pill";

export type UserStatus = "active" | "inactive";

interface StatusPillProps {
  status: UserStatus;
}

const StatusPill: React.FC<StatusPillProps> = ({ status }) => {
  const className =
    status === "active"
      ? "status-pill active"
      : "status-pill inactive";

  const label = status === "active" ? "Active" : "Inactive";

  return <Pill className={className}>{label}</Pill>;
};

export default StatusPill;
